import { registerComponentSkin } from '../components/skins/ComponentSkinLoader';

/**
 * 외부 컴포넌트 스킨 등록
 */

// WithCookie S3에 호스팅된 실제 로그인 스킨
registerComponentSkin({
  id: 'login-sample-01',
  name: '로그인 샘플 스킨 01',
  componentTypes: ['LOGIN'],
  umdUrl: 'https://withcookie-bucket.s3.ap-northeast-2.amazonaws.com/skin/components/login/sample01/login-skin.umd.js',
  cssUrls: [
    'https://withcookie-bucket.s3.ap-northeast-2.amazonaws.com/skin/components/login/sample01/login-skin.css'
  ],
  globalName: 'WithCookieLoginSkin', // 실제 전역 변수명으로 수정
  description: 'WithCookie에서 제공하는 로그인 샘플 스킨',
  author: 'WithCookie',
  version: '1.0.0'
});